<template>
  <Row id="item_wrap">
    <Col span="12" v-for="(item, index) in items" :key="index" class="item_list">
      <Row>
        <Col class="item_list_top" span="24"><Icon type="ios-cube" /><span>{{item.lable}}</span></Col>
        <Col span="10"><h2>{{item.totalCount}}</h2></Col>
        <Col span="14">
          <p class="item_list_detail"><span>市民上报</span>{{item.smsbCount}}</p>
          <p class="item_list_detail"><span>其他上报</span>{{item.qtsbCount}}</p>
        </Col>
      </Row>
    </Col>
  </Row>
</template>
<script>
export default {
  data() {
    return {
      items: [
        {
          lable: "待处理事件",
          totalCount: 0,
          smsbCount: 0,
          qtsbCount: 0,
        },
        {
          lable: "已处理事件",
          totalCount: 0,
          smsbCount: 0,
          qtsbCount: 0,
        },
        {
          lable: "延期梳理事件",
          totalCount: 0,
          smsbCount: 0,
          qtsbCount: 0,
        },
        {
          lable: "待复核事件",
          totalCount: 0,
          smsbCount: 0,
          qtsbCount: 0,
        },
      ],
      searchItem: {
        endTime: "",
        pageNumber: 1,
        pageSize: 50,
        sort: 2,
        startTime: "",
      },
    };
  },
  methods: {
    reach(v) {
      this.searchItem.startTime = v.start;
      this.searchItem.endTime = v.end;
      this.getData();
    },
    getData() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-ep-server-event/event/reportCount",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data;
        this.items=data;
      });
    },
  },
};
</script>
<style lang="">
#item_wrap {
  width: 100%;
  height: calc(100% - 10px);
  text-align: left;
}
#item_wrap .item_list .ivu-row{
  background: #044673;
  padding: 10px 15px 20px 15px;
  margin: 10px;
  border-radius: 10px;
}
#item_wrap .item_list h2{
  font-size: 44px;
  font-weight: bold;
  color: #fef968;
  text-align: right;
  margin-right: 10px;
}
#item_wrap .item_list_top{
  color: #43a4f3;
  font-size: 18px;
  margin-bottom: 12px;
}
#item_wrap .item_list_top span{
  margin-left: 4px;
  font-size: 16px;
}
#item_wrap .item_list_detail{
  margin-bottom: 4px;
}
#item_wrap .item_list_detail span{
  margin-right: 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/control/paigongxiangmu.vue